"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = require("../types/propTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultOptions = {
  useCssModules: true
};

var _default = function _default(options) {
  var computedOptions = _objectSpread({}, defaultOptions, options);

  _propTypes.default.checkPropTypes((0, _propTypes2.MakeFlagIconOptionsPropType)(), computedOptions, 'key', 'FlagIconFactory options');

  return computedOptions;
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-flag-icon-css/lib/functions/options.js
// module id = 341
// module chunks = 168707334958949